import { EnvironmentProvider } from '@publicisgroupe/p-os-components';
import { RootApp } from './RootApp';

export const Root = () => (
  <EnvironmentProvider moduleName="webframe">
    <RootApp />
  </EnvironmentProvider>
);
